module.exports = __webpack_public_path__ + "img/Stemness-MELA_GSE185386.1bcf8a07.png";